//this module defines all activated options on every jwplayer

import { createUuid } from '../uuid'
import { addSpecialTargets } from '../ads-targets'
import hasItems from '../has-items'

const optionsJwPlayer = ({ jwId, targeting, advertising, platformPrefix = 'stol7' }) => {
  addSpecialTargets(targeting)
  const targetURI =
    hasItems(targeting) &&
    encodeURIComponent(
      Object.keys(targeting)
        .map((key) => `${key}=${targeting[key]}`)
        .join('&'),
    )
  const descriptionUrl = encodeURIComponent(
    platformPrefix == 'stol7' ? 'https://www.stol.it/videos' : 'https://www.sportnews.bz/videos',
  )
  const adNetworkId = '2273514'
  const tag = (adUnit) =>
    `//pubads.g.doubleclick.net/gampad/live/ads?iu=/${adNetworkId}/${adUnit}&description_url=${descriptionUrl}&tfcd=0&npa=0&sz=640x360&cust_params=${targetURI}&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=`
  const options = {
    playerScript:
      platformPrefix == 'stol7'
        ? 'https://cdn.jwplayer.com/libraries/VjLBFSOg.js'
        : 'https://cdn.jwplayer.com/libraries/7IiPeqXq.js',
    customProps: {
      ga: {
        label: 'title',
      },
      related: {
        file:
          platformPrefix == 'stol7'
            ? 'https://cdn.jwplayer.com/v2/playlists/DOyrebfq'
            : 'https://cdn.jwplayer.com/v2/playlists/B8BQuZ0y',
      },
      displaytitle: false,
      displaydescription: false,
    },
  }

  console.log('PFP: ', platformPrefix)
  if (advertising) {
    options.customProps.advertising = {
      client: 'googima',
      schedule: [
        {
          offset: 'pre',
          tag: tag(platformPrefix + '_video_pre'),
        },
        {
          offset: 'post',
          tag: tag(platformPrefix + '_video_post'),
        },
      ],
    }
  }
  if (jwId) {
    options.playerId = createUuid() + jwId
    options.playlist = `https://cdn.jwplayer.com/v2/media/${jwId}`
  }
  return options
}

optionsJwPlayer.defaultProps = {
  advertising: true,
}

export default optionsJwPlayer
